import React from "react";
import mask1 from "../../../../assets/finbot/mask1.svg";

function Footer() {
    return (
        <div className="mt-10 relative">
  
            <h1 className="text-center text-3xl font-bold mb-5">Finbot</h1>
            <h1 className="text-center text-lg sm:text-2xl mb-5 font-medium">
                Helping crypto businesses with AI powered accounting
            </h1>
            <h1 className="text-center text-base font-normal mb-10">
                Copyright © 2023. All rights reserved.
            </h1>
        </div>
    );
}

export default Footer;
